import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { PRICING, PRICING_OPTIONS, VALUE_STACK } from '../../data/content';
export function ValueStack() {
  const megapack = PRICING_OPTIONS[0];
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-277" data-mp="1bufwiu9jim79">
      <div className="mx-auto max-w-3xl" data-id="element-278" data-mp="1buzcw6jjl2j6">
        <Reveal className="text-center" data-id="element-279" data-mp="o4c29di8rysx">
          <SectionBadge data-id="element-280" data-mp="o5eq1ck9pl4m">El paquete completo</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-281" data-mp="k3a28ugi3ipw">
            Todo lo que recibís <span className="u-lime" data-id="element-282" data-mp="xvgfa7ocx9l4">en un solo lugar</span>
          </h2>
        </Reveal>

        <Reveal delay={90} className="mt-8" data-id="element-283" data-mp="t3ge6bwjwamy">
          <div className="overflow-hidden rounded-2xl border border-white/10 bg-ink/90" data-id="element-284" data-mp="t1lpqnm2m0e4">
            <ul data-id="element-285" data-mp="5caz3yyfpmdp">
              {VALUE_STACK.map(item => <li key={item.label} className="flex items-start justify-between gap-4 border-b border-ink-line px-5 py-3.5 last:border-b-0" data-id="element-286" data-mp="dzmxhko2zsb">
                  <span className="flex items-start gap-3" data-id="element-287" data-mp="2oodhzmp7scdw">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-288" data-mp="2tfvg82zuryv6" />
                    <span data-id="element-289" data-mp="2yeyl9nfu2535">
                      <span className="block text-sm font-bold text-snow" data-id="element-290" data-mp="2yf81ijb2sxvn">{item.label}</span>
                      <span className="mt-0.5 block text-xs text-snow-muted" data-id="element-291" data-mp="20rpsr8hezvrn">{item.detail}</span>
                    </span>
                  </span>
                  <span className={`whitespace-nowrap text-sm ${item.strike ? 'text-snow-dim line-through' : 'font-bold text-snow'}`} data-id="element-292" data-mp="25qj8l7k6byuz">
                    {item.value}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-center justify-between gap-4 bg-ink-soft px-5 py-4" data-id="element-293" data-mp="3q64d7glegwhc">
              <span className="text-sm font-extrabold uppercase tracking-wide text-snow" data-id="element-294" data-mp="3q7yywx4hwsmh">Valor total real</span>
              <span className="font-display text-2xl text-snow-dim line-through" data-id="element-295" data-mp="1m2jmye1hdl2v">{PRICING.totalValueOld}</span>
            </div>
          </div>
        </Reveal>

        {megapack && <Reveal delay={140} className="mt-4" data-id="element-296" data-mp="1zzomrwalpnpo">
            <div className="rounded-2xl border-2 border-lime bg-ink/90 px-6 py-7 text-center" data-id="element-297" data-mp="1v40xlgw4cuk6">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-lime" data-id="element-298" data-mp="17ef0r037yrfc">Precio de hoy</p>
              <p className="mt-3 font-display text-5xl leading-none text-snow" data-id="element-299" data-mp="13d378jh85m1v">
                {megapack.price}{' '}
                <span className="font-sans text-base font-bold text-snow-muted" data-id="element-300" data-mp="1h4htr0acc5do">{PRICING.currency}</span>
              </p>
              <p className="mt-3 text-sm font-semibold text-snow-muted" data-id="element-301" data-mp="1canf4b9leglg">
                Un pago único · acceso inmediato ·{' '}
                <span className="text-snow" data-id="element-302" data-mp="jokr0re75izb">te queda de por vida</span>
              </p>
            </div>
          </Reveal>}
      </div>
    </section>;
}